import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import BiModule from "@/views/BiModule.vue";
import BiMsb from "@/views/BiMsb.vue";
import BiExperts from "@/views/BiExperts.vue";
import BiMarket from "@/views/BiMarket.vue";
import NotFound from "@/views/NotFound.vue";
import BiExpertsByTaskId from "@/components/TopExperts/BiExpertsByTaskId.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "",
    name: "BiModule",
    component: BiModule,
    redirect: { name: "BiMsb" },
    children: [
      {
        name: "BiMsb",
        path: "/",
        component: BiMsb
      },
      {
        name: "BiExperts",
        path: "experts",
        component: BiExperts
      },
      {
        name: "BiMarket",
        path: "market",
        component: BiMarket
      }
    ]
  },
  {
    name: "BiExpertsByTaskId",
    path: "/experts/:taskId",
    component: BiExpertsByTaskId
  },
  { path: "*", component: NotFound }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
